import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './HowItWorksPage.css';

export default function HowItWorksPage() {
  return (
    <div className="hiw-page">
      <SEO
        title="How It Works — halfprice.ca | Winnipeg Restaurant Deals"
        description="Three steps to save up to 50% at Winnipeg restaurants. Browse deals, enter your email, show your code. No account needed, no credit card, no hassle."
        url="/how-it-works"
      />
      <div className="hiw-hero">
        <div className="container text-center">
          <h1 className="font-display hiw-title">How halfprice.ca works</h1>
          <p className="hiw-sub">Connecting Winnipeg shoppers with the best local businesses since 2025.</p>
        </div>
      </div>

      <div className="container">
        {/* For shoppers */}
        <div className="hiw-section">
          <div className="hiw-section-tag">For shoppers</div>
          <h2 className="hiw-section-title font-display">Save up to 50% at local businesses</h2>
          <div className="hiw-steps">
            {[
              { num: '1', icon: '🔍', title: 'Browse local deals', desc: 'Explore hundreds of deals from Winnipeg restaurants, spas, fitness studios, services and more. Filter by neighbourhood or category.' },
              { num: '2', icon: '📧', title: 'Claim with your email', desc: 'No account required. Just enter your email address and receive a unique redemption code instantly — right on screen.' },
              { num: '3', icon: '🎉', title: 'Show up and save', desc: 'Visit the business before the deal expires, show your code, and enjoy your half-price experience. It\'s that simple.' },
            ].map(s => (
              <div key={s.num} className="hiw-step">
                <div className="hiw-step-num">{s.num}</div>
                <div className="hiw-step-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="hiw-cta-row">
            <Link to="/deals" className="btn btn-primary btn-lg">Browse deals now →</Link>
          </div>
        </div>

        <div className="hiw-divider" />

        {/* For businesses */}
        <div className="hiw-section">
          <div className="hiw-section-tag biz-tag">For businesses</div>
          <h2 className="hiw-section-title font-display">Reach thousands of Winnipeg customers</h2>
          <div className="hiw-steps">
            {[
              { num: '1', icon: '📝', title: 'Register in 2 minutes', desc: 'Create your business account, add your details, and choose your deal. We verify and your listing goes live instantly.' },
              { num: '2', icon: '🏷', title: 'Publish your deal', desc: 'Set your original price, deal price, and expiry date. Our system calculates the discount and shows it to deal-seekers in Winnipeg.' },
              { num: '3', icon: '📊', title: 'Track performance', desc: 'Watch views, clicks, and redemptions in real time on your dashboard. Pause or edit deals anytime. No contracts.' },
            ].map(s => (
              <div key={s.num} className="hiw-step">
                <div className="hiw-step-num biz-num">{s.num}</div>
                <div className="hiw-step-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="hiw-value-props">
            <div className="vp-card">
              <div className="vp-icon">💰</div>
              <h4>Zero commission</h4>
              <p>We never take a cut of your sales. Flat monthly fee only.</p>
            </div>
            <div className="vp-card">
              <div className="vp-icon">⚡</div>
              <h4>Live in minutes</h4>
              <p>No approval wait time. Publish a deal and it's live immediately.</p>
            </div>
            <div className="vp-card">
              <div className="vp-icon">📍</div>
              <h4>Local targeting</h4>
              <p>Reach shoppers in your specific Winnipeg neighbourhood.</p>
            </div>
            <div className="vp-card">
              <div className="vp-icon">🔄</div>
              <h4>Flexible</h4>
              <p>Pause, edit, or delete deals anytime. Cancel your plan anytime.</p>
            </div>
          </div>
          <div className="hiw-cta-row">
            <Link to="/business/register" className="btn btn-primary btn-lg">List your business free →</Link>
            <Link to="/pricing" className="btn btn-ghost btn-lg">View pricing</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
